import {TooltipContent, TooltipFloat, attachTooltips, removeTooltips} from "./components/Tooltip";

export {TooltipContent, TooltipFloat, attachTooltips, removeTooltips};


// WEBPACK FOOTER //
// ./src/components/tooltip/index.jsx